import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { isDev } from 'src/app/utils/utils';
import { AuthService } from 'src/services/auth.service';
@Component({
  selector: 'app-admin-ai-tester',
  templateUrl: './admin-ai-tester.component.html',
  styleUrls: ['./admin-ai-tester.component.scss'],
})
export class AdminAiTesterComponent {
  readonly TESTING_MODES = [
    {
      value: 'SINGLE',
      label: 'Single Agent Chat',
    },
    {
      value: 'DOUBLE',
      label: 'Agent Comparison Chat',
    },
  ];
  selectedMode: string = this.TESTING_MODES[0].value;

  constructor(
    private authService: AuthService,
    private modalCtrl: ModalController,
  ) {}

  isDev() {
    return this.authService.isSuperAdmin || isDev();
  }

  onDismissRunQueryModal() {
    this.modalCtrl.dismiss();
  }
}
